if (!customElements.get('nsm-real-life')) {
  customElements.define('nsm-real-life', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.videos = [];
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) entry.target.pause();
        }));
      }
      this.querySelectorAll('.nsm-real-life__media').forEach(media => {
        let video = media.querySelector('video');
        const button = media.querySelector('button');
        const template = media.querySelector('template');
        if (!button || !template) return;
        const attach = () => {
          video.muted = true;
          video.defaultMuted = true;
          video.volume = 0;
          video.controls = false;
          const revealFrame = () => media.classList.add('has-frame');
          video.addEventListener('loadeddata', revealFrame, options);
          video.addEventListener('playing', revealFrame, options);
          if (video.readyState >= 2) revealFrame();
          this.videos.push(video);
          this.observer?.observe(video);
          video.addEventListener('volumechange', () => {
            if (!video.muted) video.muted = true;
            if (video.volume !== 0) video.volume = 0;
          }, options);
          const stopped = () => {
            media.classList.remove('is-playing');
            button.setAttribute('aria-label', button.dataset.playLabel);
            button.disabled = false;
          };
          video.addEventListener('play', () => {
            document.querySelectorAll('nsm-real-life video').forEach(other => {
              if (other !== video) other.pause();
            });
            media.classList.add('is-playing');
            button.setAttribute('aria-label', button.dataset.pauseLabel);
          }, options);
          video.addEventListener('pause', stopped, options);
          video.addEventListener('ended', stopped, options);
          video.addEventListener('error', () => {
            media.classList.remove('has-frame');
            stopped();
          }, options);
        };
        if (video) attach();
        button.hidden = false;
        button.addEventListener('click', async () => {
          if (!video) {
            media.append(template.content.cloneNode(true));
            video = media.querySelector('video');
            if (!video) return;
            attach();
          }
          if (!video.paused) { video.pause(); return; }
          video.muted = true;
          video.volume = 0;
          button.disabled = true;
          if (video.error) video.load();
          try {
            await video.play();
            if (document.hidden || !this.isConnected) video.pause();
          }
          catch { media.classList.remove('is-playing'); }
          finally { button.disabled = false; }
        }, options);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}
